import React, { useEffect, useReducer, useState } from "react";
import { observer } from "mobx-react-lite";
import { withStyles } from "@material-ui/core/styles/index";
import Table from "../../../components/Table/Table";
import Scroll from "../../../components/InfiniteScroll/Scroll";
import styles from "./MotivoCancelamentoStyle";
import HeaderConfiguracoesButtonNovo from "../Components/HeaderConfiguracoesButtonNovo";
import PageTitle from "../../../components/PageTitle/PageTitle";
import { pageConfiguracoes } from "../../../utils/getPageTitle";
import Notification from "../../../components/Notification";
import {
  columns,
  motivoCancelamentoDefault,
  notificationDefault,
  pageableDTODefault,
} from "./Constants";
import { inject } from "mobx-react";
import {
  findAllMotivoCancelamentoLimitado,
  findMotivoCancelamentoLimitadoById,
  saveMotivoCancelamento,
} from "../../../services/MotivoCancelamentoService";
import MotivoCancelamentoModal from "./MotivoCancelamentoModal";
import ButtonFloat from "../../../components/ButtonFloat";
import { Button } from "../../../components/ui/Buttons";
import AddIcon from "../../../components/Icon/AddIcon";

const MotivoCancelamento = observer(({ classes, modalConfiguracoesStore }) => {
  const [motivosCancelamento, setMotivosCancelamento] = useState([]);
  const [search, setSearch] = useState("");
  const [last, setLast] = useState(true);
  const [pageableDTO, setPageableDTO] = useState(pageableDTODefault);
  const [loading, setLoading] = useReducer((state) => !state, false);
  const [notification, setNotification] = useState(notificationDefault);
  const [
    motivoCancelamentoSelecionado,
    setMotivoCancelamentoSelecionado,
  ] = useState(motivoCancelamentoDefault);

  const { showModal } = modalConfiguracoesStore;

  useEffect(() => {
    loadMotivosCancelamento({ isClear: true });
  }, [pageableDTO.sortDir, pageableDTO.sortField]);

  const handleCreate = () => {
    setMotivoCancelamentoSelecionado(motivoCancelamentoDefault);
    modalConfiguracoesStore.showModal = true;
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    setSearch(value);
  };

  const onKeypressSearch = (e) => {
    if (e.key === "Enter") {
      handleClickSearch();
    }
  };

  const handleClickSearch = () => {
    setPageableDTO({ ...pageableDTO, pageNumber: 0 });
    loadMotivosCancelamento({ isClear: true });
  };

  const handleClickClear = () => {
    setSearch("");
    setPageableDTO({ ...pageableDTO, pageNumber: 0 });
    loadMotivosCancelamento({ isClear: true, isClearSearching: true });
  };

  const openNotification = ({ message, type }) => {
    setNotification({
      open: true,
      type,
      message,
    });

    const timeoutId = setTimeout(() => {
      resetNotification();
      clearTimeout(timeoutId);
    }, 4000);
  };

  const resetNotification = () => {
    setNotification(notificationDefault);
  };

  const closeAlertMessage = () => {
    setNotification(notificationDefault);
  };

  const loadMotivosCancelamento = async (options) => {
    try {
      setLoading(true);

      const pageable = {
        ...pageableDTO,
        pageNumber: options?.isClear ? 0 : pageableDTO.pageNumber,
      };

      const textSearch = options?.isClearSearching ? "" : search;

      const response = await findAllMotivoCancelamentoLimitado({
        search: textSearch,
        pageableDTO: pageable,
      });

      const { content, last } = response;

      setMotivosCancelamento(
        options?.isClear ? content : [...motivosCancelamento, ...content]
      );
      setLast(last);
      setPageableDTO({ ...pageableDTO, pageNumber: pageable.pageNumber + 1 });
    } catch (e) {
      openNotification({
        message: "Erro ao carregar os motivos do cancelamento",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleClickOrdenar = (value) => {
    const sortDir =
      pageableDTO.sortField !== value
        ? "ASC"
        : pageableDTO.sortDir === "ASC"
        ? "DESC"
        : "ASC";
    setPageableDTO({
      ...pageableDTO,
      pageNumber: 0,
      sortDir: sortDir,
      sortField: value,
    });
  };

  const handleSelectMotivoCancelamento = async (motivoCancelamentoId) => {
    const response = await findMotivoCancelamentoLimitadoById({
      findMotivoCancelamentoLimitadoById: motivoCancelamentoId,
    });

    setMotivoCancelamentoSelecionado({
      ...response,
    });
    modalConfiguracoesStore.showModal = true;
  };

  const handleDuplicar = async (motivoCancelamentoId) => {
    const response = await findMotivoCancelamentoLimitadoById({
      findMotivoCancelamentoLimitadoById: motivoCancelamentoId,
    });

    setMotivoCancelamentoSelecionado({
      ...response,
      id: null,
    });
    modalConfiguracoesStore.showModal = true;
  };

  const handleDesativar = async (row) => {
    try {
      const variables = {
        ...row,
        ativo: false,
      };

      await saveMotivoCancelamento(variables);
      loadMotivosCancelamento({ isClear: true });
    } catch (e) {
      openNotification({
        message: "Erro ao inativar o motivo do cancelamento",
        type: "error",
      });
    }
  };

  const handleAtivar = async (row) => {
    try {
      const variables = {
        ...row,
        ativo: true,
      };

      await saveMotivoCancelamento(variables);
      loadMotivosCancelamento({ isClear: true });
    } catch (e) {
      openNotification({
        message: "Erro ao ativar o motivo do cancelamento",
        type: "error",
      });
    }
  };

  const onCloseModal = () => {
    modalConfiguracoesStore.showModal = false;
  };

  return (
    <div className={classes.container}>
      <PageTitle title={pageConfiguracoes("Motivos do cancelamento")} />
      <HeaderConfiguracoesButtonNovo
        idPrefix='cfg-mca'
        title="Motivos de cancelamento"
        labelButton="Novo Motivo"
        handleClickNovo={handleCreate}
        search={{
          handleChange: handleSearchChange,
          value: search,
          onKeypress: onKeypressSearch,
          handleClickClear: handleClickClear,
          onClickButtonSearch: handleClickSearch,
        }}
        propsTabsAuditoria={{
          tabSelected: { tabSelected: 0 },
          changeTabAuditoriaSelected: () => {},
        }}
      />

      <div className={classes.content}>
        <div className={classes.tableContainer}>
          <Scroll
            loadMore={() => loadMotivosCancelamento()}
            hasMore={last}
            pageStart={0}
            initialLoad={false}
            className={classes.scrollContainer}
            isLoading={loading}
          >
            {motivosCancelamento?.length > 0 && (
              <Table
                id='cfg-mca-tbl-mot'
                dados={motivosCancelamento}
                columns={columns({
                  functions: {
                    handleEdit: handleSelectMotivoCancelamento,
                    handleDuplicar,
                    handleDesativar,
                    handleAtivar,
                  },
                })}
                clickable={true}
                handleClick={handleSelectMotivoCancelamento}
                ordenarTabela={{
                  sortField: pageableDTO.sortField,
                  sortDir: pageableDTO.sortDir,
                }}
                comOrdenacao
                handleClickOrdenar={handleClickOrdenar}
              />
            )}
          </Scroll>
          <Button
            id='cfg-mca-btn-nov'
            shape="circle"
            bgColor="#26ACA9"
            onClick={handleCreate}
            shadow
            className={classes.buttonCriar}
          >
            <AddIcon />
          </Button>
          <ButtonFloat onClick={() => handleCreate()} />
        </div>
      </div>
      {showModal && (
        <MotivoCancelamentoModal
          open={showModal}
          onClose={onCloseModal}
          motivoCancelamentoSelecionado={motivoCancelamentoSelecionado}
          loadMotivosCancelamento={loadMotivosCancelamento}
          openNotification={openNotification}
        />
      )}
      <Notification
        close={closeAlertMessage}
        reset={closeAlertMessage}
        isOpen={notification.open}
        variant={notification.type}
        message={notification.message}
      />
    </div>
  );
});

const MotivoCancelamentoWithStyles = withStyles(styles)(MotivoCancelamento);
export default inject("modalConfiguracoesStore")(MotivoCancelamentoWithStyles);
